import { useRef, useEffect } from "react";

type Callback = (args: {
  topPercent: number;
  bottomPercent: number;
  fromBottom: number;
  fromTop: number;
  leftPercent: number;
  rightPercent: number;
  fromRight: number;
  fromLeft: number;
}) => void;

export default function useScrollTriggers(callback: Callback) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const listener = (e: { target: EventTarget | null }) => {
      const target = e.target as Element;

      const top = target.scrollTop / target.scrollHeight;
      const bottom =
        (target.scrollTop + target.clientHeight) / target.scrollHeight;

      const left = target.scrollLeft / target.scrollWidth;
      const right =
        (target.scrollLeft + target.clientWidth) / target.scrollWidth;

      callback({
        topPercent: top,
        bottomPercent: bottom,
        fromBottom:
          target.scrollHeight - (target.scrollTop + target.clientHeight),
        fromTop: target.scrollTop,

        leftPercent: left,
        rightPercent: right,
        fromRight:
          target.scrollWidth - (target.scrollLeft + target.clientWidth),
        fromLeft: target.scrollLeft,
      });
    };

    listener({ target: element });
    element.addEventListener("scroll", listener);

    return () => {
      element.removeEventListener("scroll", listener);
    };
  }, [callback]);

  return ref;
}
